<template>
  <label class="radio">
    <input
      v-show="showRadioButton"
      :id="`radio-${name}`"
      class="radio__input"
      type="radio"
      :value="name"
      v-model="radioButtonValue"
      :name="groupName"
    />
    <radio-sprite v-show="showRadioButton" class="radio__sprite" :active="value === name" />

    <div class="radio__label w-full">
      <slot />
    </div>
  </label>
</template>

<script>
import RadioSprite from "./radio-sprite"

export default {
  name: "Radio",
  components: {
    RadioSprite
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    groupName: {
      type: String,
      default: ""
    },
    showRadioButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    radioButtonValue: {
      get: function () {
        return this.value
      },
      set: function () {
        this.$emit("input", this.name)
      }
    }
  }
}
</script>

<style lang="scss">
.radio {
  $root: &;

  display: flex;
  align-items: center;

  &__input {
    display: none;
  }

  &__sprite {
    margin-right: $spacing-8;
  }

  &__label {
    @include font-style(p);

    display: flex;
    flex-wrap: wrap;
    align-items: center;

    cursor: pointer;
  }
}
</style>
